import { Container } from '@material-ui/core';
import { useStyles } from 'features/app/components/ProfilePicture/styles';
import React from 'react';

interface ProfilePictureProps {}

export const ProfilePicture: React.FC<ProfilePictureProps> = () => {
  const classes = useStyles();

  return <Container className={classes.root}>{<></>}</Container>;
};
